function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { lookupChannelUser } from '@/actions/ChannelActions';
import { Avatar, Box, Button, Divider, HStack, Heading, Icon, IconButton, Link, Modal, ModalContent, ModalOverlay, Stack, Text, Tooltip, VStack, useToken } from '@chakra-ui/react';
import { serializeProviderUserId } from '@/utils/user';
import { FormattedMessage, useIntl } from 'react-intl';
import dayjs from 'dayjs';
import Sensor from '../icons/lord/Sensor';
import { LordIconSizes } from '@/types/client';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './GiveawayWinnerModal.module.css';
import Confetti from 'react-confetti';
import { SocketContext } from '../providers/SocketProvider';
import useIntlMemo from '@/hooks/useIntlMemo';
function GiveawayWinnerModal(param) {
    var onClose = param.onClose, winner = param.winner, channel = param.channel, rightElement = param.rightElement;
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(null), 2), user = _React_useState[0], setUser = _React_useState[1];
    var _React_useState1 = _sliced_to_array(React.useState([]), 2), messages = _React_useState1[0], setMessages = _React_useState1[1];
    var socketClient = React.useContext(SocketContext);
    var _React_useState2 = _sliced_to_array(React.useState(0), 2), stopwatch = _React_useState2[0], setStopwatch = _React_useState2[1];
    var _useToken = _sliced_to_array(useToken('colors', [
        'red.300',
        'orange.300',
        'yellow.300',
        'green.300',
        'blue.300'
    ]), 5), red = _useToken[0], orange = _useToken[1], yellow = _useToken[2], green = _useToken[3], blue = _useToken[4];
    React.useEffect(function() {
        if (channel == null || winner == null) {
            return;
        }
        setMessages([]);
        setUser(null);
        lookupChannelUser(channel._id, winner.name).then(function(data) {
            return setUser(data);
        }).catch(function(error) {
            return console.error(error);
        });
    }, [
        winner,
        channel
    ]);
    var winnerIsActive = (messages === null || messages === void 0 ? void 0 : messages.length) > 0;
    React.useEffect(function() {
        if (winner == null || winnerIsActive) {
            return;
        }
        setStopwatch(0);
        var interval = setInterval(function() {
            setStopwatch(function(prev) {
                return prev + 1;
            });
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        winner,
        winnerIsActive
    ]);
    React.useEffect(function() {
        var handleChatMessage = function handleChatMessage(payload) {
            var user = payload.user;
            if (winner == null || serializeProviderUserId(user) !== serializeProviderUserId(winner)) {
                return;
            }
            setMessages(function(prev) {
                return [
                    payload
                ].concat(_to_consumable_array(prev));
            });
        };
        if (socketClient == null || winner == null || channel == null) {
            return;
        }
        socketClient.on('chatMessage', handleChatMessage);
        return function() {
            socketClient.off('chatMessage', handleChatMessage);
        };
    }, [
        channel,
        socketClient,
        winner
    ]);
    var followingStatus = useIntlMemo(function(intl) {
        if ((user === null || user === void 0 ? void 0 : user.following) == null) {
            return intl.formatMessage({
                id: "yx3ldI",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Following Status Unknown"
                    }
                ]
            });
        }
        var date = dayjs(user.following);
        if (date.valueOf() === 0) {
            return intl.formatMessage({
                id: "HsHCNl",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Not Followed"
                    }
                ]
            });
        }
        return intl.formatMessage({
            id: "B7E5fT",
            defaultMessage: [
                {
                    type: 0,
                    value: "Followed "
                },
                {
                    type: 1,
                    value: "date"
                }
            ]
        }, {
            date: date.fromNow()
        });
    }, [
        user === null || user === void 0 ? void 0 : user.following
    ]);
    if (winner == null) {
        return null;
    }
    var _user_profileUrl;
    return /*#__PURE__*/ _jsxs(Modal, {
        isOpen: winner != null,
        onClose: onClose,
        size: "xl",
        isCentered: true,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsxs(ModalContent, {
                backgroundColor: "backgroundPrimary",
                children: [
                    /*#__PURE__*/ _jsxs(Stack, {
                        spacing: 0,
                        flex: 1,
                        position: "relative",
                        overflow: "hidden",
                        children: [
                            /*#__PURE__*/ _jsxs(HStack, {
                                justifyContent: "space-between",
                                px: 4,
                                py: 2,
                                children: [
                                    /*#__PURE__*/ _jsx(Heading, {
                                        size: "sm",
                                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                            id: "H+vBOj",
                                            defaultMessage: "Winner"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(IconButton, {
                                        size: "sm",
                                        variant: "ghost",
                                        "aria-label": intl.formatMessage({
                                            id: "u3Ma1L",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Close Winner Modal"
                                                }
                                            ]
                                        }),
                                        icon: /*#__PURE__*/ _jsx(Icon, {
                                            as: FontAwesomeIcon,
                                            icon: faClose
                                        }),
                                        onClick: onClose
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                borderColor: "borderSecondary"
                            }),
                            /*#__PURE__*/ _jsxs(HStack, {
                                p: 4,
                                spacing: 4,
                                children: [
                                    /*#__PURE__*/ _jsx(Avatar, {
                                        src: user === null || user === void 0 ? void 0 : user.avatar
                                    }),
                                    /*#__PURE__*/ _jsxs(Stack, {
                                        spacing: 0,
                                        children: [
                                            /*#__PURE__*/ _jsx(Heading, {
                                                size: "sm",
                                                as: Link,
                                                color: "textPrimary",
                                                href: (_user_profileUrl = user === null || user === void 0 ? void 0 : user.profileUrl) !== null && _user_profileUrl !== void 0 ? _user_profileUrl : '',
                                                isExternal: true,
                                                children: winner === null || winner === void 0 ? void 0 : winner.displayName
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                fontSize: "sm",
                                                color: "textSecondary",
                                                children: followingStatus
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(Tooltip, {
                                        label: intl.formatMessage({
                                            id: "QtTFb9",
                                            defaultMessage: [
                                                {
                                                    type: 0,
                                                    value: "Time taken to become active"
                                                }
                                            ]
                                        }),
                                        hasArrow: true,
                                        placement: "top",
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            marginLeft: "auto",
                                            fontWeight: 600,
                                            backgroundColor: !winnerIsActive ? 'backgroundSecondary' : 'greenAlpha.300',
                                            color: !winnerIsActive ? 'textPrimary' : 'success',
                                            paddingX: 1,
                                            borderRadius: "md",
                                            borderWidth: 1,
                                            borderColor: !winnerIsActive ? 'borderSecondary' : 'greenAlpha.400',
                                            children: dayjs().startOf('day').add(stopwatch, 'second').format('HH:mm:ss')
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Divider, {
                                borderColor: "borderSecondary"
                            }),
                            messages.length > 0 ? /*#__PURE__*/ _jsx(Stack, {
                                p: 4,
                                spacing: 2,
                                overflow: "scroll",
                                className: styles.messages,
                                children: messages.map(function(param) {
                                    var message = param.message, messageId = param.messageId, date = param.date;
                                    return /*#__PURE__*/ _jsxs(HStack, {
                                        spacing: 2,
                                        fontSize: "sm",
                                        alignItems: "flex-start",
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                color: "textSecondary",
                                                children: dayjs(date).format('HH:mm:ss')
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: message
                                            })
                                        ]
                                    }, messageId);
                                })
                            }) : /*#__PURE__*/ _jsx(Box, {
                                flexGrow: 1,
                                display: "grid",
                                placeItems: "center",
                                color: "textTertiary",
                                className: styles.messages,
                                bgGradient: "linear(to-t, backgroundSecondary, backgroundPrimary)",
                                children: /*#__PURE__*/ _jsxs(VStack, {
                                    gap: 0,
                                    children: [
                                        /*#__PURE__*/ _jsx(Sensor, {
                                            trigger: "loop",
                                            size: LordIconSizes.LARGE
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            size: "sm",
                                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                                id: "FJNy4z",
                                                defaultMessage: "Waiting for Messages"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(Confetti, {
                                recycle: false,
                                colors: [
                                    red,
                                    orange,
                                    yellow,
                                    green,
                                    blue
                                ],
                                className: styles.confetti
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Divider, {
                        borderColor: "borderSecondary"
                    }),
                    /*#__PURE__*/ _jsxs(HStack, {
                        spacing: 4,
                        padding: 4,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                size: "sm",
                                onClick: function() {
                                    return onClose();
                                },
                                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                    id: "rbrahO",
                                    defaultMessage: "Close"
                                })
                            }),
                            rightElement
                        ]
                    })
                ]
            })
        ]
    });
}
export default GiveawayWinnerModal;
